import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AuthguardService,
  GeocodeService,
  HttpService,
  PoiService,
} from '../../shared/services';
import {
  AlertOptions,
  BusinessType,
  ConfirmOptions,
  DataTable,
  DataTableToCsv,
  Field,
  MESSAGE_LEVEL,
  Record,
} from '@galigeo-store/shared-models';
import {
  EventService,
  LanguageService,
  MessageService,
  ModalService,
  StepperOptions,
  TableComponent,
} from '../../shared/components';
import { saveAs } from 'file-saver';
import localEn from 'air-datepicker/locale/en';
import localFr from 'air-datepicker/locale/fr';
import { LocaleNetworkComponent } from 'src/app/shared/locales/localeNetworkComponent';
import { AbstractContainer } from 'src/app/shared/models/abstractContainer';
import { Alert } from 'src/app/shared/models/alert';
import { Network } from 'src/app/shared/models/network';
enum StepNames {
  NETWORK_NAME = 'networkName',
  ADD_LOGO = 'addLogo',
}

@Component({
  selector: 'retail-network-container',
  templateUrl: './network.component.html',
  styleUrls: ['./network.component.css'],
})
export class NetworkContainerComponent
  extends AbstractContainer
  implements OnInit
{
  public clickedRow!: any;
  public placeholder!: string;
  public everyNetworkName!: string[];
  public alreadyExist!: boolean;
  public validLength: boolean = true;
  public geocodageAlertArray: Alert[] = [];
  public geocodageAlertActive: boolean = false;
  showMap: boolean = false;
  @ViewChild(TableComponent)
  table!: TableComponent;

  networkMenuOptions!: any;
  public StepNames = StepNames;
  poisLogoBase64: any = undefined;
  addPoi: boolean = false;
  stepperOptions!: StepperOptions;
  dialogStep!: any;
  insideIframe: boolean = false;

  constructor(
    override poiService: PoiService,
    override router: Router,
    override route: ActivatedRoute,
    override translateService: LanguageService,
    override messageService: MessageService,
    override eventService: EventService,
    override authguardService: AuthguardService,
    override geocoderService: GeocodeService,
    override modalService: ModalService,
    override httpService: HttpService,
  ) {
    super(
      poiService,
      router,
      route,
      translateService,
      messageService,
      eventService,
      authguardService,
      geocoderService,
      modalService,
      httpService,
    );
    this.tableOptions = {
      withBorders: true,
      canEdit: true,
      resizable: false,
      width: '100%',
      multiSelect: true,
      pageSize: 21,
    };
    if (this.authguardService.user.lang) {
      if (this.authguardService.user.lang == 'fr') {
        this.translateService.setLang(this.authguardService.user.lang);
      } else {
        this.translateService.setLang('en');
      }
    } else if (navigator.language.startsWith('fr'))
      this.translateService.setLang('fr');
    this.translateService.addTranslation(
      'NetworkComponent',
      new LocaleNetworkComponent().locale,
    );
  }
  changeDefaultNetwork(e: any) {
    this.poiService
      .saveNetwork({
        id: this.network?.id,
        name: undefined,
        pois: undefined,
        logo: undefined,
        isDefault: e,
      })
      .subscribe((network: DataTable) => {
        console.log('default network updated', network, this.network);
      });
  }

  initOptions() {
    console.log('editNetwork', this.authguardService.user);

    this.tableOptions.canEdit =
      this.authguardService.hasCapability('editNetwork');
    this.tableOptions.datePickerLang =
      this.translateService.lang === 'fr' ? localFr : localEn;
    this.registerTableEvents();
    this.initializeNetworkOptions();
    this.initializeStepperOptions();
    this.loadNetwork();
  }

  initializeNetworkOptions() {
    this.networkListOptions = {
      label: 'Networks',
      items: [],
    };
    this.importLogoOptions.title = this.translate('import_logo_title');
    this.networkMenuOptions = [
      {
        icon: 'utility:edit',
        label: this.translate('rename'),
        action: 'rename',
      },
      {
        icon: 'utility:copy',
        label: this.translate('duplicate'),
        action: 'duplicate',
      },
      /*{
            icon: 'utility:new_direct_message',
            label: this.translate('edit'),
            subitems: [
                {
                    icon: 'utility:image',
                    label: this.translate('update_logo'),
                    action: 'changeLogo',
                } , {
              icon: 'utility:table',
              label: this.translate('identify_fields'),
              action: 'identifyFields'
              },{
                    icon: 'utility:download',
                    label: this.translate('update_network'),
                    action: 'update',
                }
            ]
        }*/ {
        icon: 'utility:download',
        label: this.translate('update_network'),
        action: 'update',
      },
      {
        color: 'red',
        icon_variant: 'error',
        divider: true,
        icon: 'utility:delete',
        label: this.translate('delete_network'),
        action: 'delete',
      },
    ];
  }

  initializeStepperOptions() {
    this.stepperOptions = new StepperOptions({
      steps: [
        {
          name: StepNames.NETWORK_NAME,
          title: this.translateService.getTranslation(
            'NetworkComponent',
            'step_network_name_title',
          ),
          label: this.translateService.getTranslation(
            'NetworkComponent',
            'step_network_name_label',
          ),
          description: this.translateService.getTranslation(
            'NetworkComponent',
            'step_network_name_description',
          ),
          btns: [
            {
              label: this.translateService.getTranslation(
                'NetworkComponent',
                'step_network_name_btn_finish_label',
              ),
              action: 'saveNetworkName',
              position: 'buttom',
              show: true,
              disabled: false,
            },
          ],
        },
        {
          name: StepNames.ADD_LOGO,
          title: this.translateService.getTranslation(
            'NetworkComponent',
            'step_add_logo_title',
          ),
          label: this.translateService.getTranslation(
            'NetworkComponent',
            'step_add_logo_label',
          ),
          description: this.translateService.getTranslation(
            'NetworkComponent',
            'step_add_logo_description',
          ),
          btns: [
            {
              label: this.translateService.getTranslation(
                'NetworkComponent',
                'step_add_logo_btn_finish_label',
              ),
              action: 'saveNetworkLogo',
              position: 'buttom',
              show: true,
              disabled: false,
            },
          ],
        },
      ],
    });
  }

  loadNetwork() {
    this.route.paramMap.subscribe((params) => {
      let networkId: any = params.get('poiSetId');
      const refreshNeeded =
        this.network?.id !== undefined && this.network.id !== networkId;
      console.log('Load networkId', networkId);

      this.poiService.getNetworks().subscribe((networks: DataTable) => {
        if (networks.data && networks.data.length > 0) {
          this.processNetworks(networkId, refreshNeeded, networks);
        } else {
          this.router.navigate(['/add/new'], {
            queryParams: HttpService.getQueryParams(),
          });
        }
      });
    });
  }

  processNetworks(networkId: any, refreshNeeded: boolean, networks: DataTable) {
    this.networkListOptions.items = networks.toJson();
    if (networkId === 'default') {
      if (this.networkListOptions.items.length > 0) {
        networkId = this.getDefaultNetworkId();
      } else {
        this.router.navigate(['/add/new'], {
          queryParams: HttpService.getQueryParams(),
        });
      }
    }

    this.sortNetworks(networks);

    this.showGlobalSpinner();
    this.loadPOISet(networkId, refreshNeeded);
  }

  getDefaultNetworkId() {
    const latestNetwork = this.findLatestItem(
      this.networkListOptions.items,
      'created_at',
    );
    const latestDefaultNetwork = this.findLatestItem(
      this.networkListOptions.items.filter(
        (item: any) => item.is_default === true,
      ),
      'created_at',
    );
    return latestDefaultNetwork
      ? latestDefaultNetwork.network_id
      : latestNetwork.network_id;
  }

  sortNetworks(dt: DataTable) {
    this.networkListOptions.items.sort((a: any, b: any) =>
      new Date(a.created_at) > new Date(b.created_at) ? -1 : 1,
    );
    this.everyNetworkName = dt.toJson().map((network: any) => network.name);
    console.log('networks', dt.toJson());
  }

  loadPOISet(networkId: any, refreshNeeded: boolean) {
    this.poiService.getPOISet(networkId).subscribe((network: DataTable) => {
      let data = network.toJson()[0];
      if (!data) {
        data = new DataTable({});
      }
      data.id = networkId;
      this.processPOISet(data, refreshNeeded);
    });
  }

  processPOISet(data: any, refreshNeeded: boolean) {
    this.disableGraphicColumns();
    this.refreshLastUpdate(data.id);
    this.loadPOIs(data, refreshNeeded);
    this.httpService.logAction('open', data.name);
  }

  loadPOIs(data: any, refreshNeeded: boolean) {
    this.poiService.getPOIs(data.id).subscribe((pois: DataTable) => {
      data.pois = pois;
      this.network = new Network(data);
      this.showMap = true;
      this.handleAccuracyIcons();
      this.handleMapRefresh(refreshNeeded);
      this.handleGeocodingAlert();
    });
  }

  handleAccuracyIcons() {
    // display accuracy icons
    if (this.network.pois?.hasBusinessType(BusinessType.GEOCODER_ACCURACY)) {
      this.configureColumns();
    }
  }

  handleMapRefresh(refreshNeeded: boolean) {
    if (refreshNeeded) {
      this.eventService.emitEvent('map', {
        action: 'refresh',
        obj: {
          setExtent: true,
          network: this.network,
        },
      });
    }
    this.hideGlobalSpinner();
  }

  handleGeocodingAlert() {
    this.route.queryParams.subscribe((params) => {
      const geocodeParam = params['geocode'];
      if (geocodeParam === 'true') {
        this.showGeocodingAlert();
        this.geocodageAlertActive = true;
      }
    });
  }

  addNetwork() {
    this.router.navigate(['add', 'new'], {
      queryParams: HttpService.getQueryParams(),
    });
  }

  cardStepperClick(event: any) {
    console.log('cardStepperClick', event);

    switch (event.btn.action) {
      case 'saveNetworkName':
        this.dialogStep = undefined;
        this.poiService
          .saveNetwork({
            id: this.network?.id,
            name: this.network?.name,
            pois: undefined,
            logo: undefined,
          })
          .subscribe((network: DataTable) => {
            console.log('network updated', network);
            this.refreshNetworksList();
          });
        break;
      case 'saveNetworkLogo':
        this.dialogStep = undefined;
        this.showMap = false;
        this.poiService
          .saveNetwork({
            id: this.network?.id,
            name: undefined,
            pois: undefined,
            logo: this.network?.logo,
          })
          .subscribe((network: DataTable) => {
            this.showMap = true;
            this.refreshNetworksList();
          });
        break;
      case 'savePoisLogo':
        this.dialogLogoEdit = undefined;
        this.updatePoisLogos();
        break;
    }
  }
  updatePoisLogos() {
    this.poiService
      .addLogo(
        this.poisLogoBase64,
        'logo-' + Math.floor(Math.random() * 100000),
      )
      .subscribe((data: DataTable) => {
        const recordId = this.rowLogoReadyForEdit.row.recordId;
        const record = {
          recordId: recordId,
          values: [data?.data[0].values[0]],
        };
        const dt = new DataTable({
          fields: [
            this.network.pois?.fields.find((f: Field) => f.name === 'logo_id')!,
          ],
          data: [record],
        });
        this.updatePoiInNetwork(dt);
      });
  }
  deleteNetwork() {
    this.messageService.confirm(
      new ConfirmOptions({
        message: this.getDeleteConfirmationMessage(),
        callback: (confirm: boolean) => {
          if (confirm && this.network.id) {
            this.handleDeleteConfirmation();
          }
        },
      }),
    );
  }

  private getDeleteConfirmationMessage() {
    return (
      this.translate('delete_network_confirm') + ' ' + this.network?.name + ' ?'
    );
  }

  private handleDeleteConfirmation() {
    this.showGlobalSpinner(this.translate('global_spinner_message_delete'));
    if (this.network?.id) {
      this.poiService
        .deleteNetwork(this.network.id)
        .subscribe((network: DataTable) => {
          console.log('network deleted', network);
          this.updateNetworkList(network);
          this.handleNetworkDeletionSuccess();
        });
    }
  }

  private updateNetworkList(network: DataTable) {
    this.networkListOptions.items = this.networkListOptions.items.filter(
      (item: any) => item.network_id + '' !== this.network?.id + '',
    );
  }

  private handleNetworkDeletionSuccess() {
    this.hideGlobalSpinner();
    this.messageService.alert(
      new AlertOptions({
        message: this.translate('delete_network_success'),
        level: MESSAGE_LEVEL.SUCCESS,
        callback: () => {
          this.navigateToLatestNetwork();
        },
      }),
    );
  }

  private navigateToLatestNetwork() {
    if (this.networkListOptions.items.length > 0) {
      const latestNetwork = this.getLatestNetwork();
      const defaultNetworks = this.networkListOptions.items.filter(
        (item: any) => item.is_default === true,
      );
      if (defaultNetworks.length > 0) {
        const latestDefaultNetwork = defaultNetworks.reduce((a: any, b: any) =>
          new Date(a.created_at) > new Date(b.created_at) ? a : b,
        );
        this.router.navigate(['/network', latestDefaultNetwork.network_id], {
          queryParams: HttpService.getQueryParams(),
        });
      } else {
        this.router.navigate(['/network', latestNetwork.network_id], {
          queryParams: HttpService.getQueryParams(),
        });
      }
    } else {
      this.router.navigate(['add', 'new'], {
        queryParams: HttpService.getQueryParams(),
      });
    }
  }

  private getLatestNetwork() {
    return this.networkListOptions.items.reduce((a: any, b: any) =>
      new Date(a.created_at) > new Date(b.created_at) ? a : b,
    );
  }

  public duplicateNetwork() {
    this.messageService.confirm(
      new ConfirmOptions({
        message:
          this.translate('duplicate_network_confirm') +
          this.network?.name +
          ' ?',
        callback: (confirm: boolean) => {
          if (confirm && this.network.id) {
            this.showGlobalSpinner(
              this.translate('global_spinner_message_duplicate'),
            );
            this.poiService
              .duplicateNetwork(this.network.id)
              .subscribe((network: DataTable) => {
                this.hideGlobalSpinner();
                console.log('network duplicated', network);
                this.networkListOptions.items.push(network.toJson()[0]);
                this.networkListOptions.items.sort((a: any, b: any) =>
                  new Date(a.created_at) > new Date(b.created_at) ? -1 : 1,
                );
                this.router.navigate(
                  ['/network', network.toJson()[0].network_id],
                  { queryParams: HttpService.getQueryParams() },
                );
              });
          }
        },
      }),
    );
  }

  closeModalEditNetwork(event: any) {
    this.dialogStep = undefined;
  }
  selectNetwork(network: any) {
    const textInputTable = document.getElementById('text-input-table');
    if (textInputTable) {
      (textInputTable as HTMLInputElement).value = '';
    }
    this.router.navigate(['/network', network.network_id], {
      queryParams: HttpService.getQueryParams(),
    });
    this.checkedRowsNb = 0;
  }
  selectMenu(event: any) {
    switch (event.action) {
      case 'rename':
        this.dialogStep = this.stepperOptions.steps.find(
          (step: any) => step.name === StepNames.NETWORK_NAME,
        );
        break;
      case 'duplicate':
        this.duplicateNetwork();
        break;
      case 'changeLogo':
        this.dialogStep = this.stepperOptions.steps.find(
          (step: any) => step.name === StepNames.ADD_LOGO,
        );
        break;
      case 'identifyFields':
        this.router.navigate(['add', this.network?.id], {
          queryParams: HttpService.getQueryParams(),
        });
        break;
      case 'update':
        this.router.navigate(['update', this.network?.id], {
          queryParams: HttpService.getQueryParams(),
        });
        break;
      case 'export':
        this.exportNetwork();
        break;
      case 'delete':
        console.log('delete');
        this.deleteNetwork();
        break;
    }
  }
  exportNetwork() {
    const dt = new DataTable({
      fields: this.network.pois?.fields,
      data: this.network.pois?.data,
    }).clone();
    const statusIdx = dt.getFieldIndex(''); // le nom pour les status
    dt.fields[statusIdx].name = 'status';
    dt.fields[statusIdx].visible = true;
    if (dt.hasBusinessType(BusinessType.GEOUNIT_CODE)) {
      dt.getFieldByBusinessType(BusinessType.GEOUNIT_CODE).visible = true;
    }
    const longitudeIdx = dt.addField({
      name: 'longitude',
      alias: 'X - Longitude',
      businessType: BusinessType.LONG,
      visible: true,
    });
    const latitudeIdx = dt.addField({
      name: 'latitude',
      alias: 'Y - Latitude',
      businessType: BusinessType.LAT,
      visible: true,
    });
    dt.data.forEach((record: Record) => {
      const status: string = record.values[statusIdx];
      if (
        status.includes(
          this.translateService.getTranslation(
            'NetworkComponent',
            'status_success',
          ),
        )
      ) {
        record.values[statusIdx] = this.translateService.getTranslation(
          'NetworkComponent',
          'status_success',
        );
      }
      if (
        status.includes(
          this.translateService.getTranslation(
            'NetworkComponent',
            'status_failed',
          ),
        )
      ) {
        record.values[statusIdx] = this.translateService.getTranslation(
          'NetworkComponent',
          'status_failed',
        );
      }
      if (
        status.includes(
          this.translateService.getTranslation(
            'NetworkComponent',
            'status_to_check',
          ),
        )
      ) {
        record.values[statusIdx] = this.translateService.getTranslation(
          'NetworkComponent',
          'status_to_check',
        );
      }
      const geomIndex = dt.getFieldIndex('geom');
      const geomVal = record.values[geomIndex];
      const coordinates = geomVal?.coordinates ?? [null, null];
      record.values[longitudeIdx] = coordinates[0];
      record.values[latitudeIdx] = coordinates[1];
    });

    const csv = DataTableToCsv.convert(dt, ';');
    var blob = new Blob([csv], { type: 'text/csv' });
    saveAs(blob, this.network.name + '.csv');
  }
  findLatestItem(items: any[], property: string): any {
    return items.length > 0
      ? items.reduce((a, b) =>
          new Date(a[property]) > new Date(b[property]) ? a : b,
        )
      : null;
  }
  ngOnInit(): void {
    if (window.self !== window.top) {
      this.insideIframe = true;
      window.parent.postMessage(
        { type: 'urlChange', url: window.location.href },
        '*',
      );
    }
    this.initOptions();
    this.placeholder = this.translateService.getTranslation(
      'NetworkComponent',
      'step_network_name_text_placeholder',
    );
  }
  translate(key: string) {
    return this.translateService.getTranslation('NetworkComponent', key);
  }
  tableAction(event: any) {
    console.log('tableAction', event);
    if (this.network && event.action === 'edit') {
      this.router.navigate(['add', this.network.id], {
        queryParams: HttpService.getQueryParams(),
      });
    }
    this.clickedRow = event.data;
  }
  onClickAddPoi() {
    this.addPoi = true;
    this.eventService.emitEvent('map', {
      action: 'activateAddPointIntheMap',
      obj: {},
    });
  }
  setNetworkName(event: any) {
    let value = event.target.value;
    let isValueAlreadyExist = this.everyNetworkName?.includes(value);

    this.alreadyExist = isValueAlreadyExist;

    let isValidLength = value.length > 1 && value.length < 31;

    this.validLength = isValidLength;

    let isButtonDisabled = isValueAlreadyExist || !isValidLength;

    this.dialogStep.btns[0].disabled = isButtonDisabled;
  }
  onLogoLoaded(event: any) {
    console.log(event.data);
    if (this.network) {
      this.network.logo = event.data;
    }
  }
  onLogoPoisChange(event: any) {
    this.poisLogoBase64 = event.data;
  }
  closeModalEditLogo(event: any) {
    this.dialogLogoEdit = undefined;
  }
  atLeastOneRowChecked() {
    return this.checkedRowsNb > 0;
  }

  closeAlertGeocodage() {
    this.geocodageAlertActive = false;
    this.router.navigate(['/network', this.network?.id], {
      queryParams: {
        ...HttpService.getQueryParams(),
        geocode: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  deleteRows() {
    if (this.network.pois?.data.length === this.checkedRowsNb) {
      this.deleteNetwork();
    } else if (this.network.id) {
      const poiIds = this.checkedRows.map((row: Record) => row.recordId);
      this.messageService.confirm(
        new ConfirmOptions({
          message: this.translateService.getTranslation(
            'NetworkComponent',
            'network_confirm_pois_delete',
          ),
          callback: (confirm: boolean) => {
            if (confirm && this.network.id) {
              this.showGlobalSpinner();
              this.poiService
                .deletePOIs({ networkId: this.network.id, poiIds })
                .subscribe(async () => {
                  this.disableGraphicColumns();
                  await this.resetNetwork(this.network.id!);
                  this.hideGlobalSpinner();
                });
            }
          },
        }),
      );
    }
    this.checkedRowsNb = 0;
  }

  showGeocodingAlert() {
    this.geocodageAlertArray = [
      {
        id: 1,
        name: 'success',
        label:
          '125 ' +
          this.translateService.getTranslation(
            'NetworkComponent',
            'step_geocodage_alert_succes_label_from_wizard',
          ),
        description: this.translateService.getTranslation(
          'NetworkComponent',
          'step_geocodage_alert_succes_description_from_wizard',
        ),
        icon: 'success',
      },
      {
        id: 2,
        name: 'warning',
        label:
          '8 ' +
          this.translateService.getTranslation(
            'NetworkComponent',
            'step_geocodage_alert_warning_label_from_wizard',
          ),
        description: this.translateService.getTranslation(
          'NetworkComponent',
          'step_geocodage_alert_warning_description_from_wizard',
        ),
        icon: 'warning',
      },
      {
        id: 3,
        name: 'error',
        label:
          '13 ' +
          this.translateService.getTranslation(
            'NetworkComponent',
            'step_geocodage_alert_error_label_from_wizard',
          ),
        description: this.translateService.getTranslation(
          'NetworkComponent',
          'step_geocodage_alert_error_description_from_wizard',
        ),
        icon: 'error',
      },
    ];
    let successGeocodable = 0;
    let warningGeocodable = 0;
    let errorGeocodable = 0;
    const indexAccuracy = this.network.pois?.getFieldIndex(
      this.network.pois?.fields.find(
        (f: Field) => f.businessType === BusinessType.GEOCODER_ACCURACY,
      )?.name ?? '',
    );

    this.network.pois?.data.forEach((record: Record) => {
      if (indexAccuracy !== undefined) {
        if (record.values[indexAccuracy] >= 0.7) {
          successGeocodable++;
        } else if (record.values[indexAccuracy] > 0) {
          warningGeocodable++;
        } else {
          errorGeocodable++;
        }
      } else if (
        indexAccuracy === -1 &&
        !this.network.pois?.hasBusinessType(BusinessType.GEOMETRY)
      ) {
        errorGeocodable++;
      } else {
        successGeocodable++;
      }
    });
    this.geocodageAlertArray[0].label =
      successGeocodable +
      ' ' +
      this.translateService.getTranslation(
        'NetworkComponent',
        'step_geocodage_alert_succes_label_from_wizard',
      );
    this.geocodageAlertArray[1].label =
      warningGeocodable +
      ' ' +
      this.translateService.getTranslation(
        'NetworkComponent',
        'step_geocodage_alert_warning_label_from_wizard',
      );
    this.geocodageAlertArray[2].label =
      errorGeocodable +
      ' ' +
      this.translateService.getTranslation(
        'NetworkComponent',
        'step_geocodage_alert_error_label_from_wizard',
      );
  }

  isSelected(subitems: any) {
    return this.network.name === subitems.name;
  }

  public static recordToDataTable(
    record: Record,
    dataTable: DataTable,
  ): DataTable {
    return new DataTable({
      fields: dataTable.fields,
      data: [record],
    });
  }

  public static DEFAULT_LOGO: string =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAALEwAACxMBAJqcGAAABhxJREFUeNrtms2PHEcVwH/vvarumZ3d9e4mNku+wDkkMgckCx8QBwQHOCKExMEnTpzyT/CfcOQIUiIuCAUZS4DAiojMlyNhYlt4E2/W3tmvme6qehxmA2ZJZDvx9GZQ/6RRa/rQ/erXVa/rVRf09PT09PT09PT09PT0nAruPOt/5Jy/SThxPvjf+ZzvcOahc8vuLJ+8xu5tNtwJ7oSbP2Yw75ilAykvTH7J+cEzFCoSKxxQIWxQEQmA0tIw5YhlHFgCApBomOIcAU7N8DheZwtnkzGwLcJkHnGHT3+JR3DAxtW3+PrhDl8eCTEqYwbkMEKXlkjDFkRokrCbDK9XqTSAFdrSMikT9rLhR7A2WqHdPsSWa+5c/S37r13mCrC1cGJ8zLOMGEbjC2srnA9wdhA5XFriIC5BHclLmRQDZRohR4pGWlUmIkwEmmC0atjoGXLr6IuB/es3GL12mZ+8/nPSvGKfb49RDIibG0hzyFJJnB1FmpVlxlZDFHKdyCFQRkOqFCgeOJSKiSuTYGQzBINciIcNk/s7bF18hWsEHnznR2wvpphbKBcg1qSSqMQYDGp0UJFFKVFJtdOKoySkMiQrsRgjjOQKrqiAt4n26Ijb64mr8UXelDX+Mc/Q5yvmAntATi2aMnUtWDBUA8EV14CLksgEFFDMIkMJaDY8AQU8t+wdTtnZXOd3bPJrWePmXOOetxgR9t2Z1pFxc0RTwN1xFYoYuThSlEorMoJlpTZjmAtVAaohh1OYHmZ22glXuMQbLPHXeUsB0A7ukSSTcgJxxCFkJ6ZClaFuYJiF4YFTTyEgWIxQV5AyoWnYUbi++W1+xh1uiswv4T7M/F/X++QhpAOBoBANiYa1homhYlhW2hI4dCE5uAAISMNuaPjN6GV+CtySV+eXbLsXA2iBoEgMUFUQDCkBNUPUiB5QG3BUHAQcn4lRIQlM+Tx73KZ0JaUbMRVWjOhKMIFgKIqJoh5QMSBgoqwHpQCOUDCkGCv7ylfat9g+c5F7wD+7EjP/HCNoA5UIgQCmFDEQwcUoGsBmM12NQkDR40IlqWEoL433+Gr5PV9z54LfnH+d1I2YiE1hQIVaBA0kMVqUJErCyKpQBTAAw4vh2VE3ZCUwOFPz0q1tvsvbfIsv8nIXYuZbEsyq5OgFAxwFj6gYEUcQSpFZTlEFHDCKgORMIBODoxTOrg0o97b4xlllx8dkWeVvCyuGaxhfQkpDzJE2BzwOkOJEcairWc+ZzXuJGELCADEHL5g5BKEyZf2g4cKd63zvhYT5HkFW+NNiigFoyQcTjlJhNw7Y2p9goxEMAk2ToZlSNJA1EBHUy2wSiGMlY5JQyeQ0Je9NqHJh5cY1Lr1yyF2/x46c5e7CiZFL7PqUg5v32U6FLQvcOdhnVY2qGG3reKw5WBrSpMQIQ0shuSM5AU7wjEpBFNrJhOn7H9C+d5+VN/7MxR/+gHdhAcUAUDH+yxbbqeXd71/mF5znCDt+Lc/ybWGHIcvH8xQnA+V4qUrIQMbYRRkxYZ0xN4ABO7zEg3mFPXcxv4K7V97hvXSf51nhD7Rk3kFZJfMcBRA2gCMEKBQSIzLQYmQA7sGs3iYDE3l1/mXB3MV8U0jnzvMgj7kjm/Ovip8WnZQE799fbnkwbaA97fY+Nl1U18Cao0sd3evp0E2w+7tZS577F4mnSVdP0YsuzjCCrsSsbhQGnT2Ep0I3wYomiKfd1ieiGzFjpr2Yj6BqLTEpna7AfVo6EfMcw1yXun8r/e9N2rJIk7tZzB2wzQdlyv5CDaVOSoIx947X/ReHruYWCyUFuhPz4YruwtDJUOLJxQyA+qH/dnxsgP0uAu5KzJMMpXP8Zzb44UrfyXjnLqdLMY+Sc4ZZT4n8dw8rJ45GB3xWekyAf28+LCdk+PGvMBP2fyUm8vE55gyQgQcwnx2Yn4Que8xHidlgJmUC3ex7eVy6XCM5ea8NZjlll8+YFOiux9TMNjYDLAOrxzIOTlvAx9GVmIeHyvrxsbO9Lp+ErsSMmA2b55n1kp3Tbvij6CrHrDFLsjULIAU6mhMAFbMPrW+fdoN7enp6enp6enp6enoeg38BugtYLM37IJgAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTItMTEtMjBUMTE6NDE6MjUrMDE6MDCFs9JmAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEyLTExLTIwVDExOjQxOjI1KzAxOjAw9O5q2gAAAABJRU5ErkJggg==';
}
